import { Component } from '@angular/core'
import { MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-submit-new-plan-confirm-modal',
  templateUrl: './submit-new-plan-confirm-modal.component.html',
  styleUrls: ['./submit-new-plan-confirm-modal.component.scss'],
  standalone: false,
})
export class SubmitNewPlanConfirmModalComponent {
  constructor(
    public dialogRef: MatDialogRef<SubmitNewPlanConfirmModalComponent>,
  ) {}

  close(confirmed: boolean) {
    this.dialogRef.close(confirmed)
  }
}
